class Cursor {
  constructor(el) {
    this.el = el
    this.cursor = null
    this.isInside = false
    this.cursor = document.createElement('div')
    this.cursor.classList.add('cursor')
    this.setupEvents()
  }

  setupEvents() {
    this.el.addEventListener('mouseenter', (e) => {
      this.isInside = true
      this.lastMoveTs = Date.now()

      // Position from the enter event before the ring can paint - it
      // used to flash at the region's 0,0 (or its stale spot on
      // re-entry) until the first mousemove placed it.
      const rect = this.el.getBoundingClientRect()
      this.cursor.style.left = (e.clientX - rect.left) + 'px'
      this.cursor.style.top  = (e.clientY - rect.top) + 'px'

      if (this.el.contains(this.cursor)) return
      this.cursor.style.opacity = 0
      this.el.appendChild(this.cursor)
    })

    this.el.addEventListener('mousemove', (e) => {
      if (!this.cursor) return

      this.isInside = true
      this.lastMoveTs = Date.now()
      this.cursor.style.opacity = 1

      const rect = this.el.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      this.cursor.style.left = x + 'px'
      this.cursor.style.top  = y + 'px'
    })

    this.el.addEventListener('mouseleave', () => {
      if (!this.cursor) return

      this.isInside = false
      this.cursor.style.opacity = 0
      this.prevX = this.prevY = null
    })
  }
}

export default Cursor